import { createFileRoute } from '@tanstack/react-router';

import { FormulaPage } from '~/features/formula/formula-page';

/** The recipe builder, with its own builder panel (board 07-formula). */
export const Route = createFileRoute('/_app/records/$recordId/customize/formula')({
  component: FormulaPage,
});
